export default __webpack_public_path__ + "static/media/edit-16px.a212acd4.svg";